module.exports = __webpack_public_path__ + "img/f35.686ac746.jpg";